import { Directive } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
  Validator,
  ValidatorFn,
} from '@angular/forms';

@Directive({
  selector: '[noOnlySpaces]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: NoOnlySpacesDirective,
      multi: true,
    },
  ],
})
export class NoOnlySpacesDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    if (control.value && control.value.trim().length === 0) {
      return { onlySpaces: true };
    }
    return null;
  }
}

@Directive({
  selector: '[noOnlySpecialChars]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: NoOnlySpecialCharsDirective,
      multi: true,
    },
  ],
})
export class NoOnlySpecialCharsDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    if (!value || typeof value !== 'string' || value.trim().length === 0) {
      return null;
    }

    const cleaned = value.replace(/\s+/g, '');
    const hasLetterOrDigit = /\p{L}|\p{N}/u.test(cleaned);

    return hasLetterOrDigit ? null : { onlySpecialChars: true };
  }
}

@Directive({
  selector: '[noOnlySpecialAlphaChars]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: NoOnlySpecialAlphaCharsDirective,
      multi: true,
    },
  ],
})
export class NoOnlySpecialAlphaCharsDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    if (!value || typeof value !== 'string' || value.trim().length === 0) {
      return null;
    }

    const cleaned = value.replace(/\s+/g, '');
    const hasAlphabet = /[a-zA-Z]/.test(cleaned);

    return hasAlphabet ? null : { onlySpecialAlphaChars: true };
  }
}
